/**
  Author - Saahil Madaan
  Git - https://bitbucket.org/techSavvySaahil/
**/

"use strict";

import {toast} from "react-toastify";

const triggerToast = (message, type = "error", properties = {}) => {
  toast(message, {
    autoClose: 5000,
    closeButton: true,
    type,
    pauseOnHover: true,
    ...properties
  });
};

export default triggerToast;
